import React from "react";
import Box from "@mui/material/Box";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import AddIcon from "@mui/icons-material/Add";
import axios from "axios";
import SweetAlert from "react-bootstrap-sweetalert";
import Pagination from "../../Pagination/Pagination";
import { useAppContext } from "../../Lib/ContextLib";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import Loader from "../Loader/Loader";
import EmptyState from "../../Components/EmptyState";
import CloseIcon from "@mui/icons-material/Close";
import FileUpload from "react-drag-n-drop-image";
import { API_URL } from "../../config";
import moment from "moment";

function CustomBody() {
  return (
    <div
      className="drag-file-area mt-0"
      style={{
        border: "0px",
        borderRadius: "0px",
        width: "100%",
        position: "relative",
      }}
    >
      <div>
        <CloudDownloadIcon style={{ fontSize: "50px" }} />
      </div>
      <h3 className="dynamic-message" style={{ fontFamily: "Montserrat" }}>
        Drag &amp; drop any file here
      </h3>
      <label className="">
        <span className="">
          <span
            className="browse-files-text"
            style={{
              fontFamily: "Montserrat",
              color: "#539ffe",
            }}
          >
            browse file
          </span>
          <span style={{ fontFamily: "Montserrat" }}>from device</span>
        </span>
      </label>
    </div>
  );
}

function ShowData({ files, onRemoveImage }) {
  return (
    <div className="">
      {files.map((item) => {
        return (
          <>
            <div
              className="drag-file-area mt-0"
              style={{
                border: "0px",
                borderRadius: "0px",
                position: "relative",
              }}
            >
              <div className="d-flex" style={{ justifyContent: "center" }}>
                <div style={{ height: "200px", width: "200px" }} className="">
                  <img
                    src={item.preview}
                    alt="Image preview..."
                    height="100%"
                    width="100%"
                    style={{ objectFit: "contain" }}
                  />
                </div>
                <CloseIcon
                  style={{
                    cursor: "pointer",
                    color: "red",
                    position: "absolute",
                    right: 10,
                    top: 10,
                  }}
                  // onClick={() => {
                  //   setDragImage2(true);
                  //   setImage2(null);
                  // }}
                  onClick={() => onRemoveImage(item.id)}
                />
              </div>
            </div>
          </>
        );
      })}
    </div>
  );
}

export default function SendNotification() {
  const { showPage, setShowPage, accessObject } = useAppContext();
  const [alert, setAlert] = React.useState(null);
  const [tableData, setTableData] = React.useState([]);
  const [rowValue, setRowValue] = React.useState();
  const [openValue, setOpenValue] = React.useState(0);
  const [loader, setLoader] = React.useState(false);
  const [showPrePage, setShowPrePage] = React.useState(10);
  const [imageFile, setImageFile] = React.useState();
  const [buttonLoader, setbuttonLoader] = React.useState(false);
  const [files, setFiles] = React.useState([]);
  const [showImages, setShowData] = React.useState(false);
  const [isEditDataImage1, setIsEditDataImage1] = React.useState(false);
  const [students, setStudents] = React.useState([]);
  const [filteredData, setFilteredData] = React.useState([]);

  const [pagination, setPagination] = React.useState({
    start: 0,
    end: showPrePage,
  });

  const onPaginationChange = (start, end) => {
    setPagination({ start: start, end: end });
  };

  const updateShowPerpagevalue = (value) => {
    setShowPrePage(value);
    setPagination({ start: 0, end: value });
  };

  const LoginSchema = Yup.object().shape({
    title: Yup.string().required("required"),
    body: Yup.string().required("required"),
    // fileData: Yup.string().required("required"),
  });

  React.useEffect(() => {
    getNotificationList();
  }, []);

  const getNotificationList = () => {
    setLoader(true);
    axios(`${API_URL}/api/player/get-player `, {
      method: "GET",
      credentials: "include",
    })
      .then((response) => {
        setLoader(false);

        setTableData(response.data.message);
        setFilteredData(response.data.message);
      })
      .catch((error) => {
        console.log("getNotificationList error :::", error);
      });
  };

  const IsEditOnRemoveImage = () => {
    setShowData(false);
    console.log("isEditOnRemove::: ");
    //  setFiles((prev) => prev.filter((i) => i.id !== id));
    setFiles([]);
    setIsEditDataImage1(false);
  };

  const onRemoveImage = (id) => {
    setShowData(false);
    setFiles((prev) => prev.filter((i) => i.id !== id));
  };

  const onError = (error) => {
    console.error(error);
  };

  const onChange = (e) => {
    if (files.length === 0) {
      console.log(e[0].file.name, "true");
      setShowData(true);
      console.log("e[0].file::: ", e[0].file);
      setImageFile(e[0].file);
      setFiles(e);
    }
  };

  const openAddTournament = (value) => {
    console.log("imageFile :::", imageFile);
    setImageFile();
    setIsEditDataImage1(false);
    setRowValue();
    console.log("openAddTournament :::", value);
    setShowPage(true);
    setOpenValue(value);
  };

  const addNewNotificcation = (value) => {
    console.log("imageFile ---", imageFile, value);

    // change image file name
    const file = imageFile;
    let originalFileName = imageFile.name.split(".");
    let fileName =
      new Date() + "." + originalFileName[originalFileName.length - 1];
    const fileWithNewName = new File([file], fileName, { type: file.type });

    const formData = new FormData();
    formData.append("image", fileWithNewName);
    // end change image file name

    axios(`${API_URL}/api/firebase/upload-image`, {
      method: "POST",
      credentials: "include",
      data: formData,
    })
      .then((result) => {
        console.log("handleSubmit result :::", result.data);
        if (result.data.isValid) {
          let merged = {
            ...value,
            imageName: fileName,
            firebaseToken: students,
          };
          console.log("merged value :::", merged);
          axios(`${API_URL}/api/firebase/send-notification-firebase-separate`, {
            method: "POST",
            credentials: "include",
            data: merged,
          })
            .then((result) => {
              console.log("handleSubmit result :::", result.data.message);
              if (result.data.isValid) {
                setbuttonLoader(false);
                successAdd(result.data.message);
              } else {
                warningAlert();
                setbuttonLoader(false);
              }
            })
            .catch((err) => {
              console.log("handleSubmit err :::", err);
              warningAlert();
            });
        }
      })
      .catch((err) => {
        console.log("handleSubmit err :::", err);
      });
  };

  const successAdd = (msg) => {
    setAlert(
      <SweetAlert
        success
        onConfirm={() => {
          getNotificationList();
          setAlert(null);
          setShowPage(false);
        }}
        customClass="premium-alert" btnSize="md" title=""
        confirmBtnClass="premium-alert-confirm"
      >
        <div className="premium-alert-title">Success!</div>
        <p className="premium-alert-text">{msg || "The notification has been sent successfully."}</p>
      </SweetAlert>
    );
  };

  const warningAlert = () => {
    setAlert(
      <SweetAlert
        warning
        onConfirm={() => setAlert(null)}
        customClass="premium-alert" btnSize="md" title=""
        confirmBtnClass="premium-alert-confirm"
      >
        <div className="premium-alert-title">Wait!</div>
        <p className="premium-alert-text">Something went wrong. Please try again later.</p>
      </SweetAlert>
    );
  };

  const addOrRemove = (firebaseToken, check, playerId) => {
    console.log("check...", check);
    console.log("playerId...", playerId);

    let createNewArray = students;

    if (check) {
      createNewArray.push(firebaseToken);
      // createNewArray[playerId] = firebaseToken;
      setStudents(createNewArray);
    } else {
      const index = createNewArray.indexOf(firebaseToken);
      if (index > -1) {
        createNewArray.splice(index, 1);
      }
      // createNewArray[playerId] = "";
      // createNewArray.splice(playerId, 1);
      setStudents(createNewArray);
    }
    console.log("createNewArray...", createNewArray);
    getNotificationList();
  };

  const filterData = (str) => {
    const emailRegex = /\S+@\S+\.\S+/;
    const nameRegex = /^[a-zA-Z\\s]*$/;
    return emailRegex.test(str) || nameRegex.test(str);
  };

  const handleFilter = (event) => {
    const searchQuery = event.target.value;
    console.log("searchQuery::: ", searchQuery);
    console.log("tableData::: ", tableData);
    const filtered = tableData

      .filter((item) => filterData(item.email) || filterData(item.name))
      .filter((item) => {
        console.log("item::: ", item);
        console.log(
          "item.email?.toLowerCase()::: ",
          item.name?.toLowerCase().includes(searchQuery)
        );
        return (
          item.email?.toLowerCase().includes(searchQuery) ||
          item.name?.toLowerCase().includes(searchQuery)
        );
      });
    setFilteredData(filtered);
  };

  return (
    <div>
      {alert}
      {showPage ? (
        <div class="content p-3 ">
          <div className="card p-3">
            <Box sx={{ width: "100%" }}>
              <Formik
                initialValues={{
                  title: rowValue ? rowValue?.title : "",
                  body: rowValue ? rowValue?.body : "",
                }}
                validationSchema={LoginSchema}
                onSubmit={(values) => {
                  setbuttonLoader(true);
                  console.log(values);

                  console.log("openValue :::", openValue);
                  if (openValue === 1) {
                    console.log("update formik value :::", openValue);
                    addNewNotificcation(values);
                  }
                }}
              >
                  {({ touched, errors, values }) => (
                    <Form>
                      <div className="row">
                        {/* Title & Body */}
                        <div className="col-md-6">
                          <div className="form-group">
                            <label>Notification Title <span className="text-danger">*</span></label>
                            <Field
                              type="text"
                              name="title"
                              placeholder="Enter Notification Title"
                              className={`mt-1 form-control ${touched.title && errors.title ? "is-invalid" : ""}`}
                            />
                            <ErrorMessage component="div" name="title" className="invalid-feedback" />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label>Notification Message <span className="text-danger">*</span></label>
                            <Field
                              type="text"
                              name="body"
                              placeholder="Enter Notification Message"
                              className={`mt-1 form-control ${touched.body && errors.body ? "is-invalid" : ""}`}
                            />
                            <ErrorMessage component="div" name="body" className="invalid-feedback" />
                          </div>
                        </div>
                      </div>

                      <div className="row mt-3">
                        {/* Image Section */}
                        <div className="col-md-12">
                          <div className="form-group">
                            <label className="mb-2">Notification Image</label>
                            {isEditDataImage1 ? (
                              <div className="file-upload-box">
                                <div className="position-relative d-inline-block">
                                  <img
                                    src={rowValue?.imageUrl}
                                    alt="preview"
                                    style={{ maxHeight: "200px", maxWidth: "100%", borderRadius: '8px' }}
                                  />
                                  <button
                                    type="button"
                                    className="btn btn-danger btn-sm position-absolute"
                                    style={{ top: -10, right: -10, borderRadius: '50%' }}
                                    onClick={() => IsEditOnRemoveImage()}
                                  >
                                    <CloseIcon fontSize="small" />
                                  </button>
                                </div>
                              </div>
                            ) : (
                              <div className="file-upload-box">
                                {showImages ? (
                                  <ShowData files={files} onRemoveImage={onRemoveImage} />
                                ) : (
                                  <FileUpload
                                    onError={onError}
                                    body={<CustomBody />}
                                    overlap={false}
                                    fileValue={files}
                                    onChange={(e) => onChange(e)}
                                  />
                                )}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="d-flex mt-4 pt-4 border-top">
                        <button
                          style={{ width: "110px" }}
                          type="submit"
                          className="btn btn-primary mr-2"
                          disabled={buttonLoader}
                        >
                          <div className="d-flex align-items-center justify-content-center">
                            <b>Submit</b>
                            {buttonLoader && (
                              <div className="spinner-border ml-2" role="status" style={{ height: "16px", width: "16px" }} />
                            )}
                          </div>
                        </button>
                        <button
                          style={{ width: "110px" }}
                          onClick={() => setShowPage(false)}
                          type="button"
                          className="btn btn-secondary ms-2"
                        >
                          Cancel
                        </button>
                      </div>
                    </Form>
                )}
              </Formik>
            </Box>
          </div>
        </div>
      ) : (
        <div className="content p-3">
          <div class="card ">
            <div className="row pl-4 pr-4 pt-4 w-100">
              <div
                className="col-4"
                style={{ display: "flex", justifyContent: "start" }}
              >
                {accessObject?.notificationSeparateSend == true && (
                  <button
                    style={{ width: "118px" }}
                    onClick={() => {
                      openAddTournament(1);
                    }}
                    type="button"
                    className="btn btn-primary btn-block "
                  >
                    Send
                  </button>
                )}
              </div>
              <div
                className="col-4"
                style={{ display: "flex", justifyContent: "center" }}
              >
                <h3 class="card-title">
                  <b>Notification List</b>
                </h3>
              </div>
              <div
                className="col-4"
                style={{ display: "flex", justifyContent: "end" }}
              >
                <input
                  class="input-simple"
                  type="text"
                  placeholder="Email And Name ..."
                  onChange={handleFilter}
                />
              </div>
            </div>

            <div class="card-body" style={{ overflow: "scroll" }}>
              <table id="" class="table table-bordered table-striped">
                <thead>
                  <tr>
                    <th style={{ textAlign: "center" }}>Action</th>
                    <th style={{ textAlign: "center" }}>SrNo</th>
                    <th style={{ textAlign: "center" }}>Date</th>
                    <th style={{ textAlign: "center" }}>Id</th>
                    <th style={{ textAlign: "center" }}>Name</th>
                    <th style={{ textAlign: "center" }}>Email</th>
                    <th style={{ textAlign: "center" }}>Balance</th>
                    <th style={{ textAlign: "center" }}>Status</th>
                  </tr>
                </thead>
                {accessObject?.getNotificationListSeparate == true ? (
                  <>
                    <tbody>
                      {!loader ? (
                        <>
                          {filteredData.length > 0 ? (
                            <>
                              {filteredData
                                ?.slice(pagination.start, pagination.end)
                                .map((item, index) => (
                                  <>
                                    <tr key={index + pagination.start}>
                                      {console.log(
                                        "students---======",
                                        students
                                      )}
                                      <td className="text-center">
                                        <input
                                          type="checkbox"
                                          id={item.playerId}
                                          onClick={(e) =>
                                            addOrRemove(
                                              item.playerId,
                                              e.target.checked,
                                              item.playerId
                                            )
                                          }
                                          checked={students.includes(
                                            item.playerId
                                          )}
                                        />
                                      </td>
                                      <td>{index + 1 + pagination.start}</td>
                                      <td>
                                        {moment(item.createdAt).format(
                                          "DD/MM/YYYY"
                                        )}
                                      </td>
                                      <td>{item.playerId}</td>
                                      <td>{item.name || "-"}</td>
                                      <td>{item.email || "-"}</td>
                                      <td>
                                        {Math.round(item.balance * 100) / 100}
                                      </td>
                                      <td>{item.playerStatus}</td>
                                    </tr>
                                  </>
                                ))}
                            </>
                          ) : (
                            <EmptyState colSpan={8} />
                          )}
                        </>
                      ) : (
                        ""
                      )}
                    </tbody>
                  </>
                ) : (
                  <>
                    <tr
                      style={{ backgroundColor: "rgba(0,0,0,.05)" }}
                      className="text-center"
                    >
                      <td colSpan={10}>
                        <h5>Access Denied</h5>
                      </td>
                    </tr>
                  </>
                )}
              </table>
              {accessObject?.getNotificationListSeparate == true && (
                <div className="mt-4">{loader && <Loader />}</div>
              )}
            </div>
            {accessObject?.getNotificationListSeparate == true &&
              filteredData.length != 0 && (
                <Pagination
                  updateShowPerpagevalue={updateShowPerpagevalue}
                  showPrePage={showPrePage}
                  onPaginationChange={onPaginationChange}
                  total={filteredData.length}
                />
              )}
          </div>
        </div>
      )}
    </div>
  );
}
